import { render } from "./WaitingSetup.vue?vue&type=template&id=6bc1f772&scoped=true"
import script from "./WaitingSetup.vue?vue&type=script&lang=js"
export * from "./WaitingSetup.vue?vue&type=script&lang=js"

import "./WaitingSetup.vue?vue&type=style&index=0&id=6bc1f772&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\eNotary.SPA\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bc1f772"]])

export default __exports__